import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { rokenStatus } from '@common/customControls/bariatrics';
import { packYearsSchema } from '@common/validation/schemas/numberSchemas';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';
import type { BariPreSecretarialAssistantMedScreeningReportDataV1 } from './bariPreSecretarialAssistantMedScreeningReportDataV1';
import {
    bariPreSecretarialAssistantMedScreeningReportBaseDraft,
    bariPreSecretarialAssistantMedScreeningReportBaseFinal,
} from '../bariPreSecretarialAssistantMedScreeningReportSchema';

const bariPreSecretarialAssistantMedScreeningReportFinalV1: TypedSchema<BariPreSecretarialAssistantMedScreeningReportDataV1> =
    {
        ...bariPreSecretarialAssistantMedScreeningReportBaseFinal,
        roken: Koi.string()
            .valid(...rokenStatus)
            .allow(null),
        roken_aantal_pack_years: packYearsSchema.allow(null),
        roken_gestopt_sinds: Koi.when('roken', {
            is: 'Gestopt sinds...',
            otherwise: Koi.valid(null),
            then: getTextAreaStringSchema(true),
        }),
        roken_toelichting: Koi.when('roken', {
            is: 'Ja',
            otherwise: Koi.when('roken', {
                is: 'Gestopt sinds...',
                otherwise: Koi.valid(null),
                then: getTextAreaStringSchema(true),
            }),
            then: getTextAreaStringSchema(true),
        }),
    };

const bariPreSecretarialAssistantMedScreeningReportDraftV1: TypedSchema<BariPreSecretarialAssistantMedScreeningReportDataV1> =
    {
        ...addAllowNull(bariPreSecretarialAssistantMedScreeningReportFinalV1),
        ...bariPreSecretarialAssistantMedScreeningReportBaseDraft,
    };

export const bariPreSecretarialAssistantMedScreeningReportDraftSchemaV1 = Koi.object(
    bariPreSecretarialAssistantMedScreeningReportDraftV1
);
export const bariPreSecretarialAssistantMedScreeningReportFinalSchemaV1 = Koi.object(
    bariPreSecretarialAssistantMedScreeningReportFinalV1
);
